<template>
    <div class="containerShadowN">
        <!-- <div class="containerEl"> -->
            <v-btn class="close" @click.prevent="closeEl()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
            <div class="ImportPatients">
                <h1>Импорт пациента</h1>
                <p>Для загрузки пациента в Систему загрузите соответствующий Системе файл формата .xml с данными пациента</p>
                <label class="input-file">
                    <!-- <input type="file" accept=".xml" @change="handleFileChange" class="input-f" name="file" id="file">
                    <input type="text" class="input-txt" placeholder="Выберите файл" v-model="file"> -->
                    <input
                        ref="file_input"
                        :value="file !== null ? file.name : 'Выберите файл'"
                        @focus="$event.target.blur()"
                        @click="selectFile"
                        placeholder="Выберите файл"
                        class="input-txt"
                    />
                    <input
                        ref="file_input_hidden"
                        type="file"
                        accept=".xml"
                        @change="setFile"
                        class="input-f"
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21.4383 11.0509L12.2483 20.2409C11.1225 21.3667 9.59552 21.9992 8.00334 21.9992C6.41115 21.9992 4.88418 21.3667 3.75834 20.2409C2.63249 19.1151 2 17.5881 2 15.9959C2 14.4037 2.63249 12.8767 3.75834 11.7509L12.9483 2.5609C13.6989 1.81033 14.7169 1.38867 15.7783 1.38867C16.8398 1.38867 17.8578 1.81033 18.6083 2.5609C19.3589 3.31146 19.7806 4.32944 19.7806 5.3909C19.7806 6.45235 19.3589 7.47033 18.6083 8.2209L9.40834 17.4109C9.03306 17.7862 8.52406 17.997 7.99334 17.997C7.46261 17.997 6.95362 17.7862 6.57834 17.4109C6.20306 17.0356 5.99222 16.5266 5.99222 15.9959C5.99222 15.4652 6.20306 14.9562 6.57834 14.5809L15.0683 6.1009" stroke="#878A91" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </label>
                <div class="btn-container">
                    <v-btn :loading="loadingSave" @click="upload()" type="button">Сохранить</v-btn>
                </div>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
import "./index.scss"
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    name: 'ImportPatients',
    computed:{
        ...mapGetters({
            apiUrl: 'apiUrl',
        })
    },
    created() {
        this.clientH = window.innerHeight;
    },
    data() {
        return {
            file: null,
            clientH: 688,
            loadingSave: false
        }
    },
    methods: {
        closeEl() {
            this.$emit(
                'closeImport', false
            )
        },
        reset() {
            this.file = null;
            this.$refs.file_input_hidden.value = null;
        },
        selectFile(event) {
            this.$refs.file_input_hidden.click(event);
        },
        setFile(event) {
            this.file = event.target.files.length > 0 ? event.target.files[0] : null;
        },
        upload() {
            this.loadingSave = true
            let formData = new FormData();
			formData.append('file', this.file);
            this.$http.post(`${this.apiUrl}Patient/ImportXml`, formData, { 'Content-Type': 'multipart/form-data' })
                .then((res) => {
                    // console.log(res.data);
                    this.loadingSave = false
                    this.reset()
                    this.closeEl()
                    // this.$emit('success');
                    // this.$emit('snackbar', {
                    //     text: 'Пациент добавлен',
                    //     color: 'success',
                    //     timeout: 5000,
                    //     show: true
                    // });
                }, (error) => {

                    if (error.response.status === 400) {
                        // this.$emit('snackbar', {
                        //     text: error.response.data,
                        //     color: 'error',
                        //     timeout: -1,
                        //     show: true
                        // });
                    }
                });
        },
        }
}
</script>
<style>

</style>